'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var slider = {};

exports.__exports = slider;
